import Trigger from './Trigger';
export default Trigger;
